import router from "@/router";
import { useUserStore } from "@/stores/user";
import { useAuth } from "@/composables/useAuth";
import { loadSecure } from "@/api/coinService";

export const initRouterRules = () => {
  router.beforeEach(async (to) => {
    const userStore = useUserStore();

    // Demo-юзер (authNeedEmail): не-demo route → привязка email;
    // на whitelisted route пропускаем БЕЗ 2fa/phone-проверок
    if (userStore.authNeedEmail) {
      if (!to.meta.showDemoVersion) {
        return { name: "ProfileSecurityVerifyEmail" };
      }
      return;
    }

    if (to.meta.need2fa || to.meta.verifyPhone) {
      const loaded = await loadSecure()
        .then(() => true)
        .catch(() => false);

      const { secure } = useAuth();

      // Ошибку загрузки secure НЕ трактуем как «2FA/телефон выключены»: иначе при
      // сетевом сбое юзера с включённой защитой кинуло бы на Need2Fa/NeedPhone.
      // Нет свежих данных (загрузка упала и стор пуст) → пропускаем, проверит сервер.
      if (!loaded && !Object.keys(secure.value).length) return;

      const isPhoneVerified = secure.value.is_phone_verified;
      const is2faEnabled =
        secure.value.is_2fa_google_enabled ||
        secure.value.is_2fa_mobile_enabled ||
        secure.value.is_2fa_passkey_enabled;

      // Редиректы возвращаем значением (не router.push без return) — иначе исходный
      // переход не отменяется и защищённый роут монтируется до второго.
      if (to.meta.need2fa && !is2faEnabled) {
        return { name: "ProfileSecurityNeed2Fa" };
      }
      if (to.meta.verifyPhone && !isPhoneVerified) {
        return { name: "ProfileSecurityNeedPhone" };
      }
    }
  });
};
